import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBR-JsgRvsm5bR9qS4Lj9jCkohemTamg9g', //process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'gcpaf-001.firebaseapp.com', //process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: 'gcpaf-001', //process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: 'gcpaf-001.appspot.com', //process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: '888092516272', //process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: '1:888092516272:web:6a9e393bc12699e4294075', //process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: 'G-WTGZBX49XL' // process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const firestore = getFirestore(app);
